import * as React from 'react';
import ReactTable, { Column } from 'react-table';
import { Link } from 'react-router-dom';
import { getRoute } from '@common/route-definitions';
import { RouteDefinitions } from '@common/route-definitions';
// import { AddressViewModel } from '@models/common.models';
import { LocalForm, Control, Errors } from 'react-redux-form';
import { getDefaultErrorMessages } from '@common/validators';
import { CheckboxInline } from '@common/components';
import { ServiceWorkOrderSearchViewModel } from '@models/ServiceWorkOrder';
import { hasValue } from '@common/validators';
import { TooltipComponent } from '@common/components/tooltip/tooltip.component';

export interface ServiceWorkOrderSearchComponentProperties {
  readonly contractId?: number;
  readonly showContractSearch?: boolean;
  readonly message: string;
  readonly query: string | null;
  readonly showInactive?: boolean | undefined;
  readonly loading: boolean;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly pageCount: number;
  readonly SWOList: Array<ServiceWorkOrderSearchViewModel>;
  readonly resetSWOSearch: () => void;
  readonly getSWOList: (
    query: string | null,
    pageSize: number,
    pageNumber: number,
    orderBy: string,
    orderDirection: string,
    showInactive?: boolean,
    contractId?: number
  ) => void;
}

interface FormModel {
  readonly query: string;
  readonly showInactive?: boolean;
}

export class ServiceWorkOrderSearchComponent extends React.Component<ServiceWorkOrderSearchComponentProperties> {
  private isInitialized = false;

  componentDidMount() {
    if (this.props.contractId) {
      this.handleSearch('', true);
    } else {
      this.props.resetSWOSearch();
    }
  }

  render() {
    let columns: Column[] = [
      {
        accessor: 'id',
        width: 100,
        Cell: (props: { value: number }) => (
          <Link to={getRoute(RouteDefinitions.serviceworkorder.Details, { id: props.value })} target="_blank">
            {props.value}
          </Link>
        ),
        Header: 'SWO#',
        sortable: true
      },
      {
        accessor: 'contract',
        width: 100,
        Cell: (props: { value: any }) => (
          <Link to={getRoute(RouteDefinitions.contract.Details, { id: props.value.id })} target="_blank">
            {props.value.number}
          </Link>
        ),
        Header: 'Contract #',
        show: this.props.contractId == null,
        sortable: false
      },
      {
        accessor: 'status',
        Header: 'Status',
        sortable: true,
        width: 175
      },
      {
        accessor: 'authoStatus',
        Header: 'Autho Status',
        sortable: true,
        width: 175
      },
      {
        accessor: 'customers[0].name',
        Header: 'Customer',
        sortable: false
      },
      {
        accessor: 'address',
        Header: 'Property Address',
        Cell: (props: { row: ServiceWorkOrderSearchViewModel }) => {
          return !props.row.contract || !props.row.contract.address
            ? '—'
            : props.row.contract.address.line1 +
                ' ' +
                props.row.contract.address.line2 +
                ', ' +
                props.row.contract.address.city +
                ', ' +
                (props.row.contract.address.state ? props.row.contract.address.state.abbreviation : '—') +
                '  ' +
                props.row.contract.address.zip;
        },
        sortable: false
      },
      {
        accessor: 'trade',
        Header: 'Issue Trade',
        sortable: false
      }
    ];

    // // don't show the contract number if they're all going to be the same...
    // if (this.props.contractId != null) {
    //   columns = columns.filter(c => c.accessor !== 'contract');
    // }

    return (
      <div>
        <LocalForm
          className="form-horizontal"
          hideNativeErrors={true}
          onSubmit={(props: FormModel) => this.handleSearch(props.query, props.showInactive)}
        >
          <div className="row">
            <div className="col-md-12">
              <h2>Service Work Order (SWO) Search</h2>
              {this.props.showContractSearch && (
                <div className="text-right">
                  <Link className="btn btn-primary" to={getRoute(RouteDefinitions.contract.Search)}>
                    Contract Search
                  </Link>
                </div>
              )}
            </div>
            <div className="form-control col-md-12">
              <label htmlFor=".query">Search</label>
              <TooltipComponent
                text="Search by any combination of SWO#, Contract#, Contract Address, Owner Name, Customer Name, Customer
                Email, Customer Phone, Address, Priority, Dispatch Type, Status, Trade Name"
                side="top"
              />
              <Control.text model=".query" validators={!this.props.contractId ? { hasValue: hasValue } : {}} />
              <Errors
                className="error"
                model=".query"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
              {this.props.pageCount * 10 > 10000 && (
                <span> Your search is too broad. Narrow the search with more specific terms. </span>
              )}
            </div>
            <div className="col-md-12">
              <div className="row end-xs text-right">
                <button className="btn btn-primary" disabled={this.props.loading} type="submit">
                  Search
                </button>
              </div>
              {!this.props.contractId && (
                <div className="row text-left">
                  <div className="col-xs-12">
                    <CheckboxInline>
                      <Control.checkbox model=".showInactive" />
                      <label>Show Inactive Contracts?</label>
                    </CheckboxInline>
                  </div>
                </div>
              )}
            </div>
          </div>
        </LocalForm>
        <ReactTable
          onPageChange={() => {
            Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
              element.scrollTop = 0;
            });
          }}
          className="-striped -highlight"
          columns={columns}
          data={this.props.SWOList}
          defaultPageSize={10}
          loading={this.props.loading}
          manual={true}
          onFetchData={this.handleFetchData}
          pages={this.props.pageCount}
        />
        {/* {this.renderError()} */}
      </div>
    );
  }
  private handleFetchData = (state: {
    page: number;
    pageSize: number;
    showInactive: boolean;
    sorted: Array<{ id: string; desc: boolean }>;
  }): void => {
    if (this.isInitialized) {
      const orderBy = state.sorted[0] ? state.sorted[0].id : 'id';
      const orderDirection = state.sorted[0] ? (state.sorted[0].desc ? 'desc' : 'asc') : 'desc';

      this.props.getSWOList(
        this.props.query,
        state.pageSize,
        state.page + 1,
        orderBy,
        orderDirection,
        this.props.showInactive,
        this.props.contractId
      );
    }
    this.isInitialized = true;
  };

  private handleSearch = (query: string, showInactive?: boolean): void => {
    this.isInitialized = true;
    this.props.getSWOList(query, this.props.pageSize, 1, 'id', 'desc', showInactive, this.props.contractId);
  };
}



// WEBPACK FOOTER //
// ./src/service-work-order/_components/service-work-order-search/service-work-order-search.component.tsx